import React from 'react';
import { ComponentInfo, SummaryNextSteps } from '@components';

export const SummaryNextStepsPlaceholder: React.FC = () => {
	return (
		<ComponentInfo name="SummaryNextStepsPlaceholder">
			<SummaryNextSteps />
		</ComponentInfo>
	);
};
